import { useState, type CSSProperties, type InputHTMLAttributes, type ReactElement } from "react";
import { palette, radius, typography } from "@ux/tokens";

export interface TextInputProps
    extends Omit<InputHTMLAttributes<HTMLInputElement>, "style"> {
    readonly invalid?: boolean;
}

export function TextInput({ invalid = false, disabled, ...rest }: TextInputProps): ReactElement {
    const [focused, setFocused] = useState(false);

    const borderColor = invalid
        ? palette.danger
        : focused
          ? palette.borderFocus
          : palette.border;

    const style: CSSProperties = {
        width: "100%",
        padding: "8px 12px",
        borderRadius: radius.md,
        border: `1px solid ${borderColor}`,
        background: palette.surfaceInset,
        color: palette.fg,
        fontFamily: typography.family.body,
        fontSize: typography.size.md,
        outline: "none",
        transition: "border-color 120ms ease",
        opacity: disabled === true ? 0.55 : 1,
    };

    return (
        <input
            {...rest}
            disabled={disabled}
            style={style}
            onFocus={(e) => {
                setFocused(true);
                rest.onFocus?.(e);
            }}
            onBlur={(e) => {
                setFocused(false);
                rest.onBlur?.(e);
            }}
        />
    );
}
